import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../App.css';

const CATEGORIES = [
  { icon: '✂', label: 'Hair' },
  { icon: '✂', label: 'Barber' },
  { icon: '💅', label: 'Nails' },
  { icon: '🧴', label: 'Skin care' },
  { icon: '👁', label: 'Brows & lashes' },
  { icon: '💆', label: 'Massage' },
  { icon: '💄', label: 'Makeup' },
  { icon: '🚗', label: 'Detailing' },
  { icon: '🎨', label: 'Tattoo' },
  { icon: '📸', label: 'Photography' },
  { icon: '🏋️', label: 'Fitness' },
  { icon: '•••', label: 'More' },
];

const PHOTOS = [
  { url: 'https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=700&q=80&auto=format&fit=crop', label: 'Barbers' },
  { url: 'https://images.unsplash.com/photo-1604654894610-df63bc536371?w=700&q=80&auto=format&fit=crop', label: 'Nail Techs' },
  { url: 'https://images.unsplash.com/photo-1559599101-f09722fb4948?w=700&q=80&auto=format&fit=crop', label: 'Tattoo Artists' },
  { url: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=700&q=80&auto=format&fit=crop', label: 'Personal Trainers' },
];

const STEPS = [
  { num: '01', title: 'Create your profile', body: 'Add your services, photos, and availability. Takes 5 minutes.' },
  { num: '02', title: 'Share your link', body: 'Drop it in your Instagram bio, TikTok, or text it to regulars.' },
  { num: '03', title: 'Get booked & paid', body: 'Clients book themselves. You just show up and work.' },
];

const TESTIMONIALS = [
  { quote: 'I used to spend 2 hours a day managing DMs. Now clients book themselves.', name: 'Marcus T.', role: 'Barber · Oakland CA', color: '#0d6b6e' },
  { quote: 'My no-show rate dropped to almost zero since I started using Vyblo.', name: 'Priya S.', role: 'Nail Tech · San Jose CA', color: '#8b4513' },
  { quote: 'Made $400 more my first month from bookings I would have missed.', name: 'Jordan R.', role: 'Tattoo Artist · Fresno CA', color: '#2d2d6b' },
];

function Counter({ to, suffix = '', duration = 1800 }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting && !started.current) {
        started.current = true;
        const start = Date.now();
        const tick = () => {
          const p = Math.min((Date.now() - start) / duration, 1);
          const eased = 1 - Math.pow(1 - p, 3);
          setCount(Math.floor(eased * to));
          if (p < 1) requestAnimationFrame(tick); else setCount(to);
        };
        requestAnimationFrame(tick);
      }
    }, { threshold: 0.3 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [to, duration]);
  return <span ref={ref}>{count.toLocaleString()}{suffix}</span>;
}

export default function Home() {
  const [scrolled, setScrolled] = useState(false);
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    navigate(`/client-dashboard?search=${encodeURIComponent(search)}`);
  };

  return (
    <div style={{ background: '#fff', fontFamily: 'DM Sans, sans-serif', color: '#0d1c1e' }}>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,800;1,700;1,800&family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700&display=swap');

        .home-nav { position: fixed; top: 0; left: 0; right: 0; z-index: 200; height: 66px; display: flex; align-items: center; justify-content: space-between; padding: 0 5%; transition: all 0.3s; }
        .home-nav.scrolled { background: rgba(255,255,255,0.97); backdrop-filter: blur(20px); border-bottom: 1px solid #e8f0f1; box-shadow: 0 2px 16px rgba(13,107,110,0.06); }

        .nav-logo-text { font-family: 'Playfair Display', serif; font-size: 1.6rem; font-weight: 800; color: #0d1c1e; text-decoration: none; letter-spacing: -0.3px; }
        .nav-logo-text span { color: #0d6b6e; }

        .nav-center { display: flex; gap: 0.25rem; position: absolute; left: 50%; transform: translateX(-50%); }
        .nav-center a { color: #3a5256; text-decoration: none; font-size: 0.875rem; font-weight: 500; padding: 0.45rem 0.875rem; border-radius: 8px; transition: all 0.18s; white-space: nowrap; }
        .nav-center a:hover { color: #0d6b6e; background: #f0fafb; }

        .nav-actions { display: flex; gap: 0.625rem; align-items: center; }
        .btn-login { background: transparent; border: 1.5px solid #c8dfe1; color: #3a5256; padding: 0.45rem 1.1rem; border-radius: 9px; font-size: 0.85rem; font-weight: 600; cursor: pointer; font-family: 'DM Sans', sans-serif; transition: all 0.2s; }
        .btn-login:hover { border-color: #0d6b6e; color: #0d6b6e; }
        .btn-signup { background: #0d6b6e; color: white; border: none; padding: 0.5rem 1.25rem; border-radius: 9px; font-size: 0.875rem; font-weight: 700; cursor: pointer; font-family: 'DM Sans', sans-serif; box-shadow: 0 2px 10px rgba(13,107,110,0.28); transition: all 0.2s; white-space: nowrap; }
        .btn-signup:hover { background: #0a5457; transform: translateY(-1px); box-shadow: 0 6px 20px rgba(13,107,110,0.38); }

        /* HERO */
        .hero-section { min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; padding: 120px 5% 80px; background: linear-gradient(180deg, #f6f9fa 0%, #edf4f5 100%); position: relative; overflow: hidden; }
        .hero-section::before { content: ''; position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: radial-gradient(ellipse 80% 60% at 50% -10%, rgba(13,107,110,0.08) 0%, transparent 60%); pointer-events: none; }

        .hero-eyebrow { display: inline-flex; align-items: center; gap: 0.5rem; background: #e0f5f6; border: 1px solid rgba(13,107,110,0.2); color: #0d6b6e; padding: 0.3rem 1rem; border-radius: 50px; font-size: 0.72rem; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase; margin-bottom: 1.75rem; }
        .hero-eyebrow-dot { width: 6px; height: 6px; border-radius: 50%; background: #3dbdc2; animation: blink 2s ease-in-out infinite; }
        @keyframes blink { 0%,100% { opacity:1; } 50% { opacity:0.4; } }

        .hero-h1 { font-family: 'Playfair Display', serif; font-size: clamp(2.8rem, 6.5vw, 5.5rem); font-weight: 800; line-height: 1.06; letter-spacing: -2px; color: #0d1c1e; margin-bottom: 1.5rem; max-width: 860px; position: relative; z-index: 1; }
        .hero-h1 em { font-style: italic; background: linear-gradient(90deg, #0d6b6e 0%, #3dbdc2 40%, #0d6b6e 60%, #3dbdc2 100%); background-size: 200% auto; -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; animation: shimmer 4s linear infinite; }
        @keyframes shimmer { 0% { background-position: -200% center; } 100% { background-position: 200% center; } }
        .stats-strip { display: grid; grid-template-columns: repeat(4, 1fr); background: white; border-top: 1px solid #e8f0f1; border-bottom: 1px solid #e8f0f1; }
        .stat-item { padding: 2.5rem 2rem; text-align: center; border-right: 1px solid #e8f0f1; }
        .stat-item:last-child { border-right: none; }
        .stat-num { font-family: 'Playfair Display', serif; font-size: 2.6rem; font-weight: 800; color: #0d6b6e; line-height: 1; margin-bottom: 0.4rem; }
        .stat-label { font-size: 0.82rem; font-weight: 700; color: #0d1c1e; margin-bottom: 0.2rem; }
        .stat-sub { font-size: 0.72rem; color: #6b8d91; }

        .hero-sub { font-size: 1.1rem; color: #6b8d91; max-width: 500px; line-height: 1.8; margin-bottom: 2.5rem; position: relative; z-index: 1; }

        /* Search bar */
        .hero-search { display: flex; align-items: center; background: white; border: 2px solid #c8dfe1; border-radius: 14px; overflow: hidden; box-shadow: 0 4px 24px rgba(13,107,110,0.1); max-width: 580px; width: 100%; margin-bottom: 2.5rem; transition: border-color 0.2s, box-shadow 0.2s; position: relative; z-index: 1; }
        .hero-search:focus-within { border-color: #0d6b6e; box-shadow: 0 4px 32px rgba(13,107,110,0.18); }
        .hero-search-icon { padding: 0 1rem 0 1.25rem; color: #a4bfc2; font-size: 1.1rem; flex-shrink: 0; }
        .hero-search input { flex: 1; border: none; outline: none; font-size: 0.95rem; color: #0d1c1e; font-family: 'DM Sans', sans-serif; padding: 1rem 0; background: transparent; }
        .hero-search input::placeholder { color: #a4bfc2; }
        .hero-search-btn { background: #0d6b6e; color: white; border: none; padding: 0.75rem 1.5rem; font-size: 0.9rem; font-weight: 700; cursor: pointer; font-family: 'DM Sans', sans-serif; transition: background 0.2s; margin: 6px; border-radius: 10px; white-space: nowrap; }
        .hero-search-btn:hover { background: #0a5457; }

        /* Category pills */
        .category-strip { display: flex; flex-wrap: wrap; gap: 0.5rem; justify-content: center; max-width: 720px; position: relative; z-index: 1; }
        .cat-pill { display: flex; align-items: center; gap: 0.4rem; background: white; border: 1.5px solid #c8dfe1; color: #3a5256; padding: 0.5rem 1.1rem; border-radius: 50px; font-size: 0.82rem; font-weight: 600; cursor: pointer; font-family: 'DM Sans', sans-serif; transition: all 0.18s; white-space: nowrap; }
        .cat-pill:hover { border-color: #0d6b6e; color: #0d6b6e; background: #f0fafb; transform: translateY(-1px); }

        /* PHOTO STRIP */
        .photo-strip { display: grid; grid-template-columns: repeat(4, 1fr); height: 340px; }
        .photo-item { position: relative; overflow: hidden; cursor: pointer; }
        .photo-item img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.6s ease; display: block; }
        .photo-item:hover img { transform: scale(1.06); }
        .photo-item::after { content: ''; position: absolute; inset: 0; background: linear-gradient(to top, rgba(5,20,22,0.6) 0%, transparent 55%); }
        .photo-label { position: absolute; bottom: 1rem; left: 1.25rem; color: white; font-size: 0.85rem; font-weight: 700; letter-spacing: 0.03em; z-index: 1; }

        /* SPLIT SECTION */
        .split-section { display: grid; grid-template-columns: 1fr 1fr; }
        .split-card { padding: 5rem 6%; display: flex; flex-direction: column; justify-content: center; }
        .split-card.left { background: #0d1c1e; }
        .split-card.right { background: #f6f9fa; }
        .split-eyebrow { font-size: 0.7rem; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; margin-bottom: 1.25rem; }
        .split-card.left .split-eyebrow { color: #3dbdc2; }
        .split-card.right .split-eyebrow { color: #0d6b6e; }
        .split-h2 { font-family: 'Playfair Display', serif; font-size: clamp(1.6rem, 2.5vw, 2.2rem); font-weight: 800; line-height: 1.2; margin-bottom: 1.25rem; letter-spacing: -0.5px; }
        .split-card.left .split-h2 { color: white; }
        .split-card.right .split-h2 { color: #0d1c1e; }
        .split-body { font-size: 0.95rem; line-height: 1.8; margin-bottom: 2rem; }
        .split-card.left .split-body { color: rgba(255,255,255,0.62); }
        .split-card.right .split-body { color: #6b8d91; }
        .split-features { display: flex; flex-direction: column; gap: 0.75rem; margin-bottom: 2.5rem; }
        .split-feature { display: flex; align-items: center; gap: 0.75rem; font-size: 0.875rem; }
        .split-card.left .split-feature { color: rgba(255,255,255,0.8); }
        .split-card.right .split-feature { color: #3a5256; }
        .split-check { width: 20px; height: 20px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 0.6rem; flex-shrink: 0; font-weight: 800; }
        .split-card.left .split-check { background: rgba(61,189,194,0.2); color: #3dbdc2; }
        .split-card.right .split-check { background: #e0f5f6; color: #0d6b6e; }
        .btn-dark { background: #0d6b6e; color: white; border: none; padding: 0.875rem 2rem; border-radius: 10px; font-size: 0.925rem; font-weight: 700; cursor: pointer; font-family: 'DM Sans', sans-serif; transition: all 0.2s; display: inline-block; text-decoration: none; }
        .btn-dark:hover { background: #0a5457; transform: translateY(-1px); box-shadow: 0 8px 24px rgba(13,107,110,0.3); }
        .btn-outline-white { background: transparent; color: white; border: 1.5px solid rgba(255,255,255,0.3); padding: 0.875rem 2rem; border-radius: 10px; font-size: 0.925rem; font-weight: 600; cursor: pointer; font-family: 'DM Sans', sans-serif; transition: all 0.2s; display: inline-block; text-decoration: none; }
        .btn-outline-white:hover { background: rgba(255,255,255,0.08); border-color: rgba(255,255,255,0.6); }

        /* HOW IT WORKS */
        .how-section { padding: 8rem 5%; background: white; text-align: center; }
        .section-label { font-size: 0.72rem; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: #0d6b6e; margin-bottom: 1rem; }
        .section-h2 { font-family: 'Playfair Display', serif; font-size: clamp(1.8rem, 3.5vw, 2.8rem); font-weight: 800; color: #0d1c1e; letter-spacing: -0.5px; line-height: 1.15; margin-bottom: 5rem; }
        .section-h2 em { font-style: italic; color: #0d6b6e; }
        .steps-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 2px; max-width: 1000px; margin: 0 auto; border: 1px solid #e8f0f1; border-radius: 20px; overflow: hidden; }
        .step-card { padding: 3rem 2.5rem; background: white; text-align: left; transition: background 0.2s; }
        .step-card:hover { background: #f6f9fa; }
        .step-card + .step-card { border-left: 1px solid #e8f0f1; }
        .step-num { font-family: 'Playfair Display', serif; font-size: 3rem; font-weight: 800; color: #e0f5f6; -webkit-text-stroke: 1.5px #0d6b6e; line-height: 1; margin-bottom: 1.5rem; }
        .step-title { font-size: 1.05rem; font-weight: 700; color: #0d1c1e; margin-bottom: 0.625rem; }
        .step-body { font-size: 0.875rem; color: #6b8d91; line-height: 1.75; }

        /* TESTIMONIALS */
        .test-section { padding: 8rem 5%; background: #f6f9fa; }
        .test-header { display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 3rem; max-width: 1100px; margin-left: auto; margin-right: auto; }
        .test-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1.5rem; max-width: 1100px; margin: 0 auto; }
        .test-card { background: white; border-radius: 18px; padding: 2rem; border: 1px solid #e8f0f1; position: relative; overflow: hidden; transition: all 0.25s; }
        .test-card:hover { transform: translateY(-3px); box-shadow: 0 16px 40px rgba(13,107,110,0.1); border-color: rgba(13,107,110,0.2); }
        .test-accent { position: absolute; top: 0; left: 0; right: 0; height: 3px; border-radius: 18px 18px 0 0; }
        .test-stars { color: #d97706; font-size: 0.8rem; letter-spacing: 2px; margin-bottom: 1rem; margin-top: 0.5rem; }
        .test-quote { font-size: 0.9rem; color: #3a5256; line-height: 1.8; margin-bottom: 1.5rem; font-style: italic; }
        .test-author { display: flex; align-items: center; gap: 0.75rem; }
        .test-avatar { width: 38px; height: 38px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 0.8rem; font-weight: 800; color: white; flex-shrink: 0; }
        .test-name { font-size: 0.875rem; font-weight: 700; color: #0d1c1e; }
        .test-role { font-size: 0.75rem; color: #6b8d91; }

        /* CTA BAND */
        .cta-band { padding: 7rem 5%; background: #0d6b6e; text-align: center; position: relative; overflow: hidden; }
        .cta-band::before { content: ''; position: absolute; inset: 0; background: radial-gradient(ellipse at 30% 50%, rgba(61,189,194,0.25) 0%, transparent 55%), radial-gradient(ellipse at 75% 30%, rgba(10,84,87,0.5) 0%, transparent 55%); }
        .cta-h2 { font-family: 'Playfair Display', serif; font-size: clamp(2rem, 4vw, 3rem); font-weight: 800; color: white; letter-spacing: -0.5px; line-height: 1.15; margin-bottom: 1.25rem; position: relative; z-index: 1; }
        .cta-h2 em { font-style: italic; color: #a8eff2; }
        .cta-sub { color: rgba(255,255,255,0.65); font-size: 1rem; margin-bottom: 2.5rem; position: relative; z-index: 1; }
        .cta-actions { display: flex; gap: 1rem; justify-content: center; flex-wrap: wrap; position: relative; z-index: 1; }
        .btn-white { background: white; color: #0d6b6e; border: none; padding: 0.875rem 2.5rem; border-radius: 10px; font-size: 0.95rem; font-weight: 700; cursor: pointer; font-family: 'DM Sans', sans-serif; transition: all 0.2s; text-decoration: none; display: inline-block; }
        .btn-white:hover { background: #f0fafb; transform: translateY(-1px); box-shadow: 0 8px 24px rgba(0,0,0,0.15); }
        .btn-ghost-white { background: transparent; color: rgba(255,255,255,0.85); border: 1.5px solid rgba(255,255,255,0.35); padding: 0.875rem 2rem; border-radius: 10px; font-size: 0.95rem; font-weight: 600; cursor: pointer; font-family: 'DM Sans', sans-serif; transition: all 0.2s; text-decoration: none; display: inline-block; }
        .btn-ghost-white:hover { background: rgba(255,255,255,0.1); border-color: rgba(255,255,255,0.7); }

        /* FOOTER */
        .home-footer { background: #0d1c1e; padding: 3.5rem 5%; }
        .footer-inner { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 2rem; max-width: 1200px; margin: 0 auto; }
        .footer-logo-text { font-family: 'Playfair Display', serif; font-size: 1.5rem; font-weight: 800; color: white; }
        .footer-logo-text span { color: #3dbdc2; }
        .footer-tagline { font-size: 0.78rem; color: rgba(255,255,255,0.35); margin-top: 0.25rem; }
        .footer-links { display: flex; gap: 2rem; flex-wrap: wrap; }
        .footer-links a { color: rgba(255,255,255,0.45); text-decoration: none; font-size: 0.82rem; font-weight: 500; transition: color 0.2s; }
        .footer-links a:hover { color: rgba(255,255,255,0.85); }
        .footer-bottom { border-top: 1px solid rgba(255,255,255,0.06); margin-top: 2rem; padding-top: 2rem; text-align: center; font-size: 0.75rem; color: rgba(255,255,255,0.2); max-width: 1200px; margin: 2rem auto 0; }

        @media (max-width: 768px) {
          .nav-center { display: none; }
          .photo-strip { grid-template-columns: repeat(2,1fr); height: 240px; }
          .split-section { grid-template-columns: 1fr; }
          .steps-grid { grid-template-columns: 1fr; }
          .step-card + .step-card { border-left: none; border-top: 1px solid #e8f0f1; }
          .test-grid { grid-template-columns: 1fr; }
          .test-header { flex-direction: column; align-items: flex-start; gap: 0.5rem; }
          .footer-inner { flex-direction: column; }
        }
      `}</style>

      {/* NAV */}
      <nav className={`home-nav ${scrolled ? 'scrolled' : ''}`}>
        <Link to="/" className="nav-logo-text">Vyb<span>lo</span></Link>
        <div className="nav-center">
          <a href="#why">Why Vyblo</a>
          <a href="#how">How it works</a>
          <a href="#providers">For Providers</a>
          <a href="#clients">For Clients</a>
        </div>
        <div className="nav-actions">
          <Link to="/login"><button className="btn-login">Log in</button></Link>
          <Link to="/signup"><button className="btn-signup">List your business</button></Link>
        </div>
      </nav>

      {/* HERO */}
      <section className="hero-section">
        <div className="hero-eyebrow">
          <span className="hero-eyebrow-dot" />
          Book any service, anywhere
        </div>
        <h1 className="hero-h1">
          Discover and book<br />
          <em>top local professionals</em><br />
          near you.
        </h1>
        <p className="hero-sub">
          Find barbers, nail techs, tattoo artists, trainers and more — instantly book and pay online.
        </p>

        {/* Search */}
        <form className="hero-search" onSubmit={handleSearch}>
          <span className="hero-search-icon">🔍</span>
          <input
            type="text"
            placeholder="Search services or businesses..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          <button type="submit" className="hero-search-btn">Search</button>
        </form>

        {/* Category pills */}
        <div className="category-strip">
          {CATEGORIES.map((cat, i) => (
            <button key={i} className="cat-pill" onClick={() => navigate(`/client-dashboard?search=${cat.label}`)}>
              {cat.label}
            </button>
          ))}
        </div>
      </section>

      {/* PHOTO STRIP */}
      <div className="photo-strip">
        {PHOTOS.map((p, i) => (
          <div key={i} className="photo-item">
            <img src={p.url} alt={p.label} loading="lazy" />
            <span className="photo-label">{p.label}</span>
          </div>
        ))}
      </div>

      {/* STATS STRIP */}
      <div className="stats-strip">
        {[
          { value: 1200, suffix: '+', label: 'Providers active', sub: 'and growing daily' },
          { value: 48000, suffix: '+', label: 'Bookings processed', sub: 'across all categories' },
          { value: 73, suffix: '%', label: 'Fewer no-shows', sub: 'with auto reminders' },
          { value: 2, suffix: 'hrs', label: 'Saved per day', sub: 'no more DM chaos' },
        ].map((s, i) => (
          <div key={i} className="stat-item">
            <div className="stat-num"><Counter to={s.value} suffix={s.suffix} /></div>
            <p className="stat-label">{s.label}</p>
            <p className="stat-sub">{s.sub}</p>
          </div>
        ))}
      </div>

      {/* SPLIT — For Providers / For Clients */}
      <div className="split-section" id="why">
        {/* Left — Providers */}
        <div className="split-card left" id="providers">
          <p className="split-eyebrow">For Providers</p>
          <h2 className="split-h2">Run your bookings.<br />Not your DMs.</h2>
          <p className="split-body">
            Vyblo gives you a professional booking page, automated reminders, and secure payments — all in one place. Set it up once and let clients book themselves.
          </p>
          <div className="split-features">
            {['Smart online booking page', 'Auto SMS & email reminders', 'Stripe-powered payments', 'Deposit & cancellation protection', 'Instant or 2-day payouts'].map((f, i) => (
              <div key={i} className="split-feature">
                <span className="split-check">✓</span>
                {f}
              </div>
            ))}
          </div>
          <Link to="/signup" className="btn-outline-white" style={{ alignSelf: 'flex-start' }}>List your business →</Link>
        </div>

        {/* Right — Clients */}
        <div className="split-card right" id="clients">
          <p className="split-eyebrow">For Clients</p>
          <h2 className="split-h2">Find & book the best,<br />near you.</h2>
          <p className="split-body">
            Browse real portfolios, read verified reviews, and book your appointment instantly — no phone calls, no waiting. Available 24/7.
          </p>
          <div className="split-features">
            {['Browse local providers with real photos', 'See live availability', 'Book & pay instantly online', 'Auto reminders so you never forget', 'Easy reschedule & cancel'].map((f, i) => (
              <div key={i} className="split-feature">
                <span className="split-check">✓</span>
                {f}
              </div>
            ))}
          </div>
          <Link to="/signup" className="btn-dark" style={{ alignSelf: 'flex-start' }}>Book an appointment →</Link>
        </div>
      </div>

      {/* HOW IT WORKS */}
      <section className="how-section" id="how">
        <p className="section-label">Simple setup</p>
        <h2 className="section-h2">Up and running<br /><em>in 3 steps</em></h2>
        <div className="steps-grid">
          {STEPS.map((s, i) => (
            <div key={i} className="step-card">
              <div className="step-num">{s.num}</div>
              <p className="step-title">{s.title}</p>
              <p className="step-body">{s.body}</p>
            </div>
          ))}
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="test-section">
        <div className="test-header">
          <div>
            <p className="section-label" style={{ marginBottom: '0.75rem' }}>Real results</p>
            <h2 className="section-h2" style={{ marginBottom: 0 }}>Service pros<br /><em>love Vyblo</em></h2>
          </div>
          <Link to="/signup" style={{ textDecoration: 'none' }}>
            <button className="btn-signup" style={{ whiteSpace: 'nowrap' }}>Get started free →</button>
          </Link>
        </div>
        <div className="test-grid">
          {TESTIMONIALS.map((t, i) => (
            <div key={i} className="test-card">
              <div className="test-accent" style={{ background: t.color }} />
              <div className="test-stars">★★★★★</div>
              <p className="test-quote">"{t.quote}"</p>
              <div className="test-author">
                <div className="test-avatar" style={{ background: t.color }}>
                  {t.name.split(' ').map(n => n[0]).join('')}
                </div>
                <div>
                  <p className="test-name">{t.name}</p>
                  <p className="test-role">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="cta-band">
        <h2 className="cta-h2">Ready to grow<br /><em>your business?</em></h2>
        <p className="cta-sub">Join thousands of service professionals running their bookings on Vyblo.</p>
        <div className="cta-actions">
          <Link to="/signup" className="btn-white">Start for free →</Link>
          <Link to="/login" className="btn-ghost-white">Log in</Link>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="home-footer">
        <div className="footer-inner">
          <div>
            <div className="footer-logo-text">Vyb<span>lo</span></div>
            <p className="footer-tagline">Run your business, not your DMs.</p>
          </div>
          <div className="footer-links">
            <a href="#why">Why Vyblo</a>
            <a href="#how">How it works</a>
            <a href="#providers">For Providers</a>
            <a href="#clients">For Clients</a>
            <Link to="/login" style={{ color: 'rgba(255,255,255,0.45)', textDecoration: 'none', fontSize: '0.82rem', fontWeight: 500 }}>Log in</Link>
            <Link to="/signup" style={{ color: 'rgba(255,255,255,0.45)', textDecoration: 'none', fontSize: '0.82rem', fontWeight: 500 }}>Sign up</Link>
          </div>
        </div>
        <div className="footer-bottom">© 2025 Vyblo. All rights reserved.</div>
      </footer>
    </div>
  );
}
